// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td[data-v-5e113c62],\nth[data-v-5e113c62] {\n  vertical-align: middle;\n}", ""]);
// Exports
module.exports = exports;
